<template>
  <div class="device-stat">
      <div class="device-status-first">
        <span class="trend-title">设备状态数据</span>
        <el-select v-model="statusDate" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="device-status">
        <span class="trend-title">关机设备数量</span>
        <el-input type="number" placeholder="请输入" v-model="staData.tfDevNum">
          <template slot="suffix">台</template>
        </el-input>
        <span class="device-status-second">
          <span class="trend-title">使用中设备数量</span>
          <el-input type="number" placeholder="请输入" v-model="staData.useDevNum">
            <template slot="suffix">台</template>
          </el-input>
        </span>
      </div>
      <div class="device-status">
        <span class="trend-title">检修设备数量</span>
        <el-input type="number" placeholder="请输入" v-model="staData.haulDevNum">
          <template slot="suffix">台</template>
        </el-input>
        <span class="device-status-second">
          <span class="trend-title">闲置中设备数量</span>
          <el-input type="number" placeholder="请输入" v-model="staData.idleDevNum">
            <template slot="suffix">台</template>
          </el-input>
        </span>
      </div>
      <div class="device-status">
        <span class="trend-title">低速运转设备数量</span>
        <el-input type="number" placeholder="请输入" v-model="staData.lowDevNum">
          <template slot="suffix">台</template>
        </el-input>
        <span class="device-status-second">
          <span class="trend-title">待出租设备数量</span>
          <el-input type="number" placeholder="请输入" v-model="staData.notHireDevNum">
            <template slot="suffix">台</template>
          </el-input>
        </span>
      </div>
      <div class="device-status">
        <span class="trend-title">正常运转设备数量</span>
        <el-input type="number" placeholder="请输入" v-model="staData.normalDevNum">
          <template slot="suffix">台</template>
        </el-input>
        <span class="device-status-second">
          <span class="trend-title">已出租设备数量</span>
          <el-input type="number" placeholder="请输入" v-model="staData.hireDevNum">
            <template slot="suffix">台</template>
          </el-input>
        </span>
      </div>
      <div class="device-status">
        <span class="trend-title">高速运转设备数量</span>
        <el-input type="number" placeholder="请输入" v-model="staData.highDevNum">
          <template slot="suffix">台</template>
        </el-input>
        <span class="device-status-second">
          <span class="trend-title">待出售设备数量</span>
          <el-input type="number" placeholder="请输入" v-model="staData.saleDevNum">
            <template slot="suffix">台</template>
          </el-input>
        </span>
      </div>
      <div class="device-status-last">
        <span class="trend-title">总数量</span>
        <el-input type="number" placeholder="请输入" v-model="staData.totalDevNum">
          <template slot="suffix">台</template>
        </el-input>
      </div>
      <div class="last-save">
         <el-button :loading="devSaLoading" size="small" @click="saveStat" type="primary">保存</el-button>
      </div>
  </div>
</template>

<script>
import api from '@/apis/device/device'
export default {
  data(){
    return{
      devSaLoading:false,//加载状态
      options: [{
        value: 0,
        label: '从后台获取'
      }, {
        value: 1,
        label: '手工录入'
      }],
      statusDate:1,

      //数据
      staData:{
        tfDevNum:'',//关机设备数量
        useDevNum:'',//使用中设备数量
        haulDevNum:'',//检修设备数量
        idleDevNum:'',//闲置中设备数量
        lowDevNum	:'',//低速运转设备数量
        notHireDevNum:'',//待出租设备数量
        normalDevNum:'',//正常运转设备数量
        hireDevNum:'',//已出租设备数量
        highDevNum:'',//高速运转设备数量
        saleDevNum:'',//待出售设备数量
        totalDevNum:'',//总数量
      },
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    //保存数据
    saveStat(){
      this.devSaLoading = true;
      api.saveState(this.staData).then(res=>{
        if(res.code==10000){
          this.devSaLoading = false;
          this.$message.success('保存成功')
        }else{
          this.devSaLoading = false;
          this.$message.error(res.message)
        }
      })
    },
    //获取数据
    getList(){
      api.getState().then(res=>{
        if(res.code==10000){
          if(res.data.length!=0){
            this.staData = res.data[0]
          }
        }
      })
    },
    //计算总和
    // sumAllDev(){
    //   this.totalDevNum = this.staData.tfDevNum==''?0:parseInt(this.staData.tfDevNum)+
    //   this.staData.useDevNum==''?0:parseInt(this.staData.useDevNum)+
    //   this.staData.haulDevNum==''?0:parseInt(this.staData.haulDevNum)+
    //   this.staData.idleDevNum==''?0:parseInt(this.staData.idleDevNum)+
    //   this.staData.lowDevNum==''?0:parseInt(this.staData.lowDevNum)+
    //   this.staData.notHireDevNum==''?0:parseInt(this.staData.notHireDevNum)+
    //   this.staData.normalDevNum==''?0:parseInt(this.staData.normalDevNum)+
    //   this.staData.hireDevNum==''?0:parseInt(this.staData.hireDevNum)+
    //   this.staData.highDevNum==''?0:parseInt(this.staData.highDevNum)+
    //   this.staData.saleDevNum==''?0:parseInt(this.staData.saleDevNum)
    // },
  }
}
</script>
<style lang="less" scoped>
.device-stat{ padding-top: 10px;
  .trend-title{ width: 8rem;}
  .el-input,.el-select{ width: 15rem;}
  .device-status{ margin-bottom: 15px;}
  .device-status-first{ margin-bottom: 1rem;}
  .device-status-second{ margin-left: 15px;}
}
</style>